import type { ChangeEvent } from "react";
import styled from "styled-components";
import { ErrorMessage } from "./ErrorMessage";
import { Typography, TypographyProps } from "./Typography";

/**
 * [共通パーツ]チェックボックス入力欄
 */
type StyledCheckInputProps = {
  value?: string;
  checked?: boolean;
  error?: boolean;
  errorMessages?: string[];
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  dataId?: string;
  disabled?: boolean;
};

export type CheckInputProps = {
  label: string;
  hideError?: boolean;
} & StyledCheckInputProps;

const StyledLabel = styled.label`
  text-align: left;
`;

const StyledTypography = styled(Typography)<TypographyProps>`
  font-size: ${(props) => props.theme.fontSize.small};
  padding-left: 5px;
  display: inline;
`;

export function CheckInput({
  label,
  value = "true",
  checked = false,
  onChange,
  errorMessages = [],
  dataId,
  disabled = false,
  hideError = false,
}: CheckInputProps) {
  return (
    <>
      <StyledLabel>
        <input
          type="checkbox"
          checked={checked}
          value={value}
          onChange={onChange}
          data-id={dataId}
          disabled={disabled}
        />
        <StyledTypography>{label}</StyledTypography>
      </StyledLabel>
      {!hideError && (
        <ErrorMessage
          errorMessage={
            errorMessages && errorMessages.find((message) => message !== "")
          }
        />
      )}
    </>
  );
}
